import dayjs from 'dayjs';

const format = 'YYYY-MM-DD HH:mm';

export const defaultShiftsPeriod = 'day';
export const defaultShiftsRange = dayjs(new Date()).format(format);
